import React from 'react';
import { Route, Routes } from 'react-router-dom';
import ScreenPreview from '../components/previewView';

export default () => (
  <Routes>
    <Route path="/preview/:id" Component={ScreenPreview} />
  </Routes>
);
